import { STUDIO, SUBJECT } from "./studio";

const formatDate = (v) =>
  v
    ? new Date(`${v}T00:00:00`).toLocaleDateString("de-DE", {
        weekday: "long",
        day: "2-digit",
        month: "long",
        year: "numeric",
      })
    : "";

export const buildRequestText = (f) => {
  const wish = [formatDate(f.date), f.daytime].filter(Boolean).join(", ") || "flexibel";
  return [
    "Hallo Aliona,",
    "",
    "ich möchte gerne einen Termin bei Maison Princess anfragen.",
    "",
    `Name: ${f.name.trim()}`,
    `E-Mail: ${f.email.trim()}`,
    `Telefon: ${f.phone.trim() || "–"}`,
    `Gewünschte Behandlung: ${f.treatment || "Noch offen / Beratung"}`,
    `Wunschtermin: ${wish}`,
    "",
    "Nachricht:",
    f.message.trim() || "–",
    "",
    "Viele Grüße",
    f.name.trim(),
  ].join("\n");
};

export const buildMailto = (body = "") => {
  const params = `subject=${encodeURIComponent(SUBJECT)}${
    body ? `&body=${encodeURIComponent(body.replace(/\n/g, "\r\n"))}` : ""
  }`;
  return `mailto:${STUDIO.email}?${params}`;
};

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  }
};
